import React from 'react';
import { ImageFile } from '~/data/types/images';

const PhoneGrayIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.208984"
        width="27.791"
        height="27.791"
        rx="13.8955"
        fill="#F5F8F9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.8195 14.1829C16.247 16.6098 16.7977 13.8022 18.3433 15.3467C19.8334 16.8364 20.6898 17.1348 18.8019 19.0222C18.5654 19.2123 17.0629 21.4987 11.7827 16.2199C6.50172 10.9404 8.78682 9.43639 8.97691 9.19998C10.8694 7.30737 11.1627 8.16877 12.6528 9.65844C14.1984 11.2036 11.392 11.7561 13.8195 14.1829Z"
        stroke="#262626"
        stroke-width="1.09537"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Component>
  );
};

export default PhoneGrayIcon;
